import React from "react";
import { Breadcrumbs, Typography, Box, Container } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { useAuth } from "../../config/AuthContext";
import routeToPermission from "../../config/routeToPermission";

const breadcrumbLinks = [
  {
    key: "TpSearchStudents",
    label: "Search Students",
    to: "/TpSearchStudents",
  },
  {
    key: "TpSearchFormerStudents",
    label: "Search Former Students",
    to: "/TpSearchFormerStudents",
  },
  {
    key: "TpSearchCoordinators",
    label: "Search Coordinators",
    to: "/TpSearchCoordinators",
  },
  {
    key: "TpSearchInstructors",
    label: "Search Instructors",
    to: "/TpSearchInstructors",
  },
  {
    key: "TpSearchFps",
    label: "Search FPS",
    to: "/TpSearchFps",
  },
  {
    key: "TpSearchCourses",
    label: "Search Courses",
    to: "/TpSearchCourses",
  },
];

const TechPrepStaffBreadCrumbs = ({ pageName }) => {
  const icon = faSearch;
  const theme = useTheme();
  const { currentUser, userPermissions } = useAuth();

  // Check if user is staff
  const isStaff = currentUser?.userTypes?.staff === true;

  // Helper to check permission - for staff users, show all links
  const canView = (areaKey) => {
    if (isStaff) {
      return true; // Staff can see all search links
    }
    const permissionName = routeToPermission[areaKey];
    return permissionName ? userPermissions[permissionName]?.view : false;
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 2 }}>
      <Box
        sx={{
          backgroundColor:
            theme.components.MuiBreadcrumbs.styleOverrides.root.backgroundColor,
          color: theme.components.MuiBreadcrumbs.styleOverrides.root.color,
          padding: "20px",
          marginTop: "0px", // Remove extra margin since dashboard has its own spacing
          marginBottom: "20px",
          borderRadius: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* Breadcrumbs Section */}
        <Box>
          <Breadcrumbs maxItems={25} separator="•" aria-label="breadcrumb">
            {breadcrumbLinks.map((link) => (
              <Link
                key={link.key}
                underline="hover"
                color="inherit"
                to={link.to}
                style={{
                  color: theme.palette.mode === "dark" ? "#ffffff" : "#ffffff",
                }}
              >
                {link.label}
              </Link>
            ))}
          </Breadcrumbs>
          <Typography
            variant="h5"
            fontWeight="bold"
            style={{
              color: theme.palette.mode === "dark" ? "#ffffff" : "#ffffff",
            }}
          >
            {pageName}
          </Typography>
        </Box>
        {/* Icon Section */}
        <Box>
          <FontAwesomeIcon icon={icon} size="4x" style={{ color: "#000" }} />
        </Box>
      </Box>
    </Container>
  );
};

export default TechPrepStaffBreadCrumbs;
